import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spinner } from '../components/ui';
import { LandingPage } from '../marketing/LandingPage';
import { useAuth } from './AuthContext';

/**
 * Gates the authenticated app. Redirects anonymous users to /login - except
 * at the exact root path, where an anonymous visitor sees the public
 * marketing/landing page instead (the "starting page" for anyone not yet
 * logged in). A signed-in user hitting `/` still gets the normal dashboard
 * (via the Outlet below), unaffected.
 */
export function ProtectedRoute() {
  const { state } = useAuth();
  const location = useLocation();

  if (state.status === 'loading') {
    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
        <Spinner label="Loading your workspace" />
      </div>
    );
  }

  if (state.status === 'anonymous') {
    if (location.pathname === '/') return <LandingPage />;
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return <Outlet />;
}

/** For /login and /register: send already-authenticated users to the app. */
export function PublicOnlyRoute() {
  const { state } = useAuth();
  if (state.status === 'loading') return null;
  if (state.status === 'authenticated') return <Navigate to="/" replace />;
  return <Outlet />;
}
